import { render, staticRenderFns } from "./AttivitaSearch.vue?vue&type=template&id=bfdb0478&scoped=true&"
import script from "./AttivitaSearch.vue?vue&type=script&lang=ts&"
export * from "./AttivitaSearch.vue?vue&type=script&lang=ts&"
import style0 from "./AttivitaSearch.vue?vue&type=style&index=0&id=bfdb0478&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdb0478",
  null
  
)

export default component.exports